import React, { useEffect } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import PropTypes from 'prop-types';

const Navigation = ({ content }) => {

    const content2 = ['财经', '股票', '国际', '港股', '风暴眼', '大赛', 'IPO观察哨', '理财', '封面', '中国深度财经', '舍得人物', '前行者', '银行财银', '产业新城'];

return (
        <div id="navigation" className={styles.col_box}>
        <div className={styles.col_navlist}>
            <div className={styles.col_nav}>
                <ul className="clearfix">
                    {
                        content.map((item, index) => {
                          
                            return (
                                <li key={index} className={index === 0 ? styles.pa : ''}>
                                    <a href={item.url} target="_blank" title={item.title} rel="noreferrer">
                                        {item.title}
                                    </a>
                                </li>
                            );
                        })
                    }
                </ul>
            </div>
        </div>
    </div>
    );
};

Navigation.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Navigation);
